import { createContext as e } from "react";
//#region src/components/Theme/ThemeContext.ts
var t = /* @__PURE__ */ function(e) {
	return e.light = "light", e.dark = "dark", e.auto = "auto", e;
}({}), n = e({
	theme: "auto",
	onThemeChange: () => {
		throw Error("onThemeChange should be used inside ThemeProvider");
	}
});
//#endregion
export { t as Theme, n as ThemeContext };
